module.exports = __webpack_public_path__ + "img/STCDisabeld.bb5d88f2.svg";